import { render } from "./salary-structures.vue?vue&type=template&id=ef4382e2&scoped=true"
import script from "./salary-structures.vue?vue&type=script&lang=js"
export * from "./salary-structures.vue?vue&type=script&lang=js"

import "./salary-structures.vue?vue&type=style&index=0&id=ef4382e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4382e2"]])

export default __exports__